<template>
  <div class="call_wrap hidden-xs-only">
    <div class="bottom_container">
      <div class="info_wrap">
        <div class="item item_wrap">
          <div class="logo_container">
            <img src="../../assets/img/navigate/logo_white.png" alt="瑞谦智能">
            <span>福建平潭瑞谦智能科技有限公司</span>
          </div>
        </div>
        <div class="item item_info_wrap">
          <div class="item_info">联系电话：400-8775178 </div>
          <div class="item_info">邮政编码：350400</div>
          <div class="item_info">电子邮箱：rqzhineng@163.com</div>
          <div class="item_info">联系地址：平潭综合实验区中山大道中段288号新兴产业园示范区1号楼</div>
        </div>
        <div class="item item_img_wrap">
          <div class="item_img">
            <img src="../../assets/img/navigate/offQR.jpg" alt="官网二维码" title="官网二维码" />
            <div class="title">官网二维码</div>
          </div>
          <div class="item_img">
            <img src="../../assets/img/navigate/wxQR.jpg" alt="公告号二维码" title="公告号二维码" />
            <div class="title">微信公众号</div>
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <div class="e_richText-1">
          <p @click="handleJump('/home')">版权所有© 福建平潭瑞谦智能科技有限公司&nbsp;&nbsp;&nbsp;</p>
          <a href="">营业执照</a>
        </div>
        <div class="e_richText-2">
          <a href="https://beian.miit.gov.cn">闽ICP备18005794号-1</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      handleJump(path) {
        if (!path) return;
        this.$router.push(path).catch( err => console.log(err) )
      }
    }
  }
</script>

<style scoped lang="scss">
.call_wrap {
  width: 100%;
  height: 368px;
  background: rgba(50, 50, 51, 1);
  .bottom_container {
    width: 100%;
    min-height: 100px;
    padding-top: 5%;
    background: rgb(60, 60, 60);
    overflow: auto;
    .info_wrap {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      width: 94%;
      max-width: 1280px;
      margin: 0 auto 2% auto;
      .item {
        display: flex;
        flex-direction: column;
      }
      .item_wrap {
        width: 100%;
        flex: 34%;
        .logo_container {
          display: flex;
          flex-direction: column;
          max-width: 266px;
          max-height: 100%;
          img {
            width: auto;
            max-width: 206px;
            margin: 22px auto;
          }
          span {
            font-size: 18px;
            color: rgb(169, 169, 169);
            line-height: 2;
            margin: 0 auto;
            text-align: center;
          }
        }
      }
      .item_info_wrap {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        flex: 44%;
        width: 100%;
        font-size: 14px;
        color: rgb(204, 204, 204);
        line-height: 2.5;
      }
      .item_img_wrap {
        flex: 22%;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        width: 100%;
        max-width: 300px;
        margin-left: auto;
        .item_img {
          max-width: 100%;
          max-height: 100%;
          img {
            width: 100%;
            max-width: 120px;
          }
          .title {
            line-height: normal;
            color: rgb(169, 169, 169);
            font-size: 14px;
            text-align: center;
            margin-top: 16px;
          }
        }
      }
    }
    .navigate_wrap{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 15px 0;
      background: rgba(50, 50, 51, 1);
      font-size: 14px;
      color: rgba(145, 145, 145, 1);
      line-height: 1.8;
      text-align: center;
      .e_richText-1 {
        flex: 1 1;
        display: flex;
        flex-direction: row;
      }
      .e_richText-2 {
      }
      a {
        font-size: 14px;
        color: rgba(145, 145, 145, 1);
      }
    }
  }
}
</style>
